/*ěščřžýáíéúů*/

var $header = $("header.site-header");
var $footer = $("footer.site-footer");
var $menuBtn = $header.find(".site-header__menu-btn");
var $mobileNav = $header.find(".site-header__nav-wrapper");
var $clickPlaceholder = $(".click-body-placeholder");
var $headerSearch = $(".header__search");
var $hideNavBreakpoint = 890;

function openNav() {
    $menuBtn.addClass("active");
    $mobileNav.addClass("active");
    $clickPlaceholder.addClass("active");
}

function hideNav() {
    $menuBtn.removeClass("active");
    $mobileNav.removeClass("active");
    $clickPlaceholder.removeClass("active");
}

let mobileMenuBreakpoint = 0;

const cssVars = () => {
    const doc = document.documentElement;
    doc.style.setProperty("--site-header-height", $(".site-header").innerHeight() + "px");
    doc.style.setProperty("--site-footer-height", $(".site-footer").innerHeight() + "px");
    if ($("#wpadminbar").length) {
        doc.style.setProperty("--adminbar-height", $("#wpadminbar").innerHeight() + "px");
    } else {
        doc.style.setProperty("--adminbar-height", "0px");
    }

    const rootStyles = getComputedStyle(doc);
    // - mobile menu breakpoint
    mobileMenuBreakpoint = parseFloat(rootStyles.getPropertyValue("--mobile-menu-breakpoint").trim());
};
window.addEventListener("resize", cssVars);
cssVars();

var fancyboxCS = {
    cs: {
        CLOSE: "Zavřít",
        NEXT: "Další",
        PREV: "Přechozí",
        ERROR: "Požadovaný obsah se nepodařilo načíst. <br/>Pokuste se o to prosím později.",
        PLAY_START: "Spustit slideshow",
        PLAY_STOP: "Pozastavit slideshow",
        FULL_SCREEN: "Celá obrazovka",
        THUMBS: "Náhledy",
        DOWNLOAD: "Stáhnout",
        SHARE: "Sdílet",
        ZOOM: "Zvětšit",
    },
};

function copyCurrentUrl(button) {
    const url = window.location.href;
    navigator.clipboard
        .writeText(url)
        .then(() => {
            button.classList.add("ok");

            setTimeout(() => {
                button.classList.remove("ok");
            }, 1000);
        })
        .catch((err) => {
            console.error("Kopírování se nezdařilo:", err);
            alert("Nepodařilo se zkopírovat odkaz.");
        });
}

        // Pokud používáš jQuery
$(document).on('click', '.icheckbox', function(e) {
    e.preventDefault(); // zabrání případnému default chování

    var $input = $(this).find('input[type="checkbox"]');
    var checked = $input.prop('checked');

    // přepnout stav
    $input.prop('checked', !checked).trigger('change');

    // pokud chceš změnit i vizuální třídu (pokud iCheck nepoužíváš plně)
    $(this).toggleClass('checked', !checked);
});

jQuery(document).ready(function ($) {
    window.$root = $("html, body");

    $(document).ready(function () {
        // Initialize iCheck for the GDPR checkbox
        $("#register-gdpr").iCheck({
            checkboxClass: "icheckbox",
        });
    });

    $.fancybox.defaults.hash = false;
    $.fancybox.defaults.loop = true;
    // fancybox images inside text content
    $("#textPage a")
        .filter(function () {
            return $(this)
                .attr("href")
                .match(/\.(jpg|jpeg|gif|png|bmp)$/i);
        })
        .fancybox({
            lang: "cs",
            i18n: fancyboxCS,
        });

    // fancyboxes
    $(".fancybox").fancybox({
        lang: "cs",
        i18n: fancyboxCS,
    });

    // manage animated scrolling
    $("body").on("click", "[data-scrollto]", function (e) {
        e.preventDefault();

        var $target = $($(this).attr("data-scrollto"));
        var minus = $(this).attr("data-scrollto-minus");
        if (minus == null) minus = 0;

        animateScroll($target, minus);

        return false;
    });

    $("a[href*='#']").on("click", function (e) {
        var href = $(this).attr("href");

        // čistá kotva nebo relativní odkaz se stejnou cestou
        if (href.startsWith("#")) {
            e.preventDefault();

            if (href !== "#") {
                var $elem = $(href);
                if ($elem.length > 0) {
                    animateScroll($elem, $("header").height());
                    if ($menuBtn.hasClass("active")) {
                        hideNav();
                    }

                }
            }
        } else {
            // vytvoříme URL pro porovnání domény a cesty
            var linkUrl = new URL(href, window.location.href);
            var currentUrl = new URL(window.location.href);

            // pokud odkaz vede na stejnou stránku (stejný path + origin)
            if (linkUrl.origin === currentUrl.origin && linkUrl.pathname === currentUrl.pathname) {
                e.preventDefault();

                if (linkUrl.hash && linkUrl.hash !== "#") {
                    var $elem = $(linkUrl.hash);
                    if ($elem.length > 0) {
                        animateScroll($elem, $("header").height());
                        if ($menuBtn.hasClass("active")) {
                            hideNav();
                        }
                    }
                }
            }
        }
    });

    $menuBtn.click(function (e) {
        e.preventDefault();
        if ($(this).hasClass("active")) {
            hideNav();
        } else {
            openNav();
        }
    });

    $clickPlaceholder.click(function (e) {
        e.preventDefault();
        if ($menuBtn.hasClass("active")) {
            hideNav();
        } else {
            if ($(window).innerWidth() <= $menuBtn) {
                openNav();
            }
        }

        if ($headerSearch.hasClass("active")) {
            $headerSearch.removeClass("active");
            $(this).removeClass("active");
        }
    });

    $headerSearch.find("button").click(function (e) {
        if ($headerSearch.hasClass("active")) {
            if ($headerSearch.find("input[name='s']").val() == "") {
                e.preventDefault();
                $headerSearch.removeClass("active");
                $clickPlaceholder.removeClass("active");
            }
        } else {
            e.preventDefault();
            $headerSearch.addClass("active");
            $clickPlaceholder.addClass("active");
        }
    });

    // Window is loaded or resized
    $(window).on("load resize", function () {
        // Wait until basic transitions ends
        setTimeout(() => {
            // equalizer
            multiEqualizer();
        }, 200);
    });

    // background images
    initBackgrounds();

    // Equalizer right when document loaded
    multiEqualizer();

    // Iframe ratio fix
    // iframeRatioFix();
});

function initBackgrounds() {
    // background images
    $("[data-background]").each(function () {
        var bg = $(this).attr("data-background");
        if (bg.length > 0) {
            $(this).css("background-image", "url(" + bg + ")");
        }
    });
}

function animateScroll($target, minus) {
    /// <summary>
    /// Animated scrolling.
    /// </summary>
    /// <param name="$target" type="element">jQuery element to scroll to.</param>
    /// <param name="minus" type="int">Amount of pixels to decrease the position.</param>

    if (minus == null) minus = 0;

    $root.animate(
        {
            scrollTop: $target.offset().top - minus,
        },
        500,
    );
}

// This function initializes multiequalizer
// - container: data-equal="key1,key2", data-equal-on="640"
// - items: data-equal-watch="key1", data-equal-watch="key2"
function multiEqualizer() {
    $("[data-equal]").each(function () {
        var $parent = $(this),
            types = $parent.attr("data-equal").split(","),
            equalOn = $parent.attr("data-equal-on"),
            equalInRow = String($parent.attr("data-equal-in-row")).toLowerCase();

        if (typeof equalOn == "undefined" || window.innerWidth >= parseInt(equalOn)) {
            $.each(types, function (i, e) {
                // Equalize in row
                if (equalInRow === "true" || equalInRow === "1") {
                    // Current item position from top
                    let rowPosY = 0;
                    let rows = [],
                        rowItems = [],
                        rowsH = [];
                    var H = 0;

                    // Prepare array of items in row
                    // Only visible - useful when filtration
                    let items = $parent.find("[data-equal-watch=" + e + "]:visible").height("auto");

                    items.each(function () {
                        let item = $(this),
                            itemPosY = item.offset().top;
                        if (itemPosY != rowPosY) {
                            rowPosY = itemPosY;
                            // Push only nonempty array (e.g. skip the first)
                            if (rowItems.length > 0) {
                                rows.push(rowItems);
                                rowsH.push(H);
                            }

                            rowItems = [];
                            H = 0;
                        }

                        var h = $(this).height();
                        if (h > H) {
                            H = h;
                        }
                        rowItems.push(item);
                    });

                    // Add final row
                    rows.push(rowItems);
                    rowsH.push(H);
                    rows.forEach(function (row, i) {
                        let H = rowsH[i];
                        row.forEach(function (item) {
                            $(item).height(H);
                        });
                    });

                    // Equalize all
                } else {
                    var H = 0;
                    // Reset the height for proper calculation on resize
                    $parent.find("[data-equal-watch=" + e + "]").height("auto");
                    // Find the highest value
                    $parent.find("[data-equal-watch=" + e + "]").each(function () {
                        var h = $(this).height();
                        if (h > H) {
                            H = h;
                        }
                    });

                    // Set the highest value to all items
                    $parent.find("[data-equal-watch=" + e + "]").height(H);
                }
            });
        } else {
            $.each(types, function (i, e) {
                $parent.find("[data-equal-watch=" + e + "]").height("auto"); // Reset the height
            });
        }
    });
}

// This function tries to fix iframe aspect ratio
function iframeRatioFix(selector = "") {
    if (!selector) {
        // Set default selector
        selector = ".gutenberg-wrapper iframe";
    }

    // Set proper width, height & aspect ratio for iframes
    let iframes = $(selector);
    if (iframes.length > 0) {
        iframes.each(function () {
            let $iframe = $(this),
                iframeW = parseInt($iframe.attr("width")),
                iframeH = parseInt($iframe.attr("height")),
                aspectRatio;

            if (iframeW && iframeH) {
                aspectRatio = iframeW + "/" + iframeH;
            } else {
                // fallback
                aspectRatio = "500/281";
            }

            $iframe.css({
                width: "100%",
                height: "initial",
                "aspect-ratio": aspectRatio,
            });
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    const swiper = new Swiper(".swiper-container", {
        loop: true,
        navigation: {
            nextEl: ".sell-btn-next", // Specifičtější selektor
            prevEl: ".sell-btn-prev",
        },

        slidesPerView: "auto",
        spaceBetween: 15,
    });

    const swiperReference = new Swiper(".swiper-reference", {
        loop: true,
        navigation: {
            nextEl: ".btn-ref-next", // Specifičtější selektor
            prevEl: ".btn-ref-prev",
        },

        slidesPerView: "auto",
        spaceBetween: 15,
    });
});

document.addEventListener("scroll", function () {
    const header = document.querySelector(".site-header");
    if (window.scrollY > 0) {
        header.classList.add("site-header--scrolled");
    } else {
        header.classList.remove("site-header--scrolled");
    }
});

document.querySelectorAll(".video-container").forEach((container) => {
    container.addEventListener("click", function () {
        const videoUrl = this.getAttribute("data-video-url");
        const iframe = document.createElement("iframe");
        iframe.setAttribute("src", videoUrl + "?autoplay=1");
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture");
        iframe.setAttribute("allowfullscreen", "");
        this.innerHTML = "";
        this.appendChild(iframe);
    });
});

/*ěščřžýáíéúů*/

/* DEFINE THIS GLOBALLY IN HTML:
<script type="text/javascript">
    var formServicesDirectory = THEME_URI + '/services/';
    var formErrorMessage = "<?php _e("Před odesláním prosím doplňte/opravte data ve formuláři.", THEME_TEXT_DOMAIN); ?>\n";
    var gdprError = "<?php _e("Před odesláním musíte souhlasit se zpracováním osobních údajů.", THEME_TEXT_DOMAIN); ?>";
</script>
 */

function initForms() {
    // Initialize AJAX form submission
    $(".register-form").on("submit", function (e) {
        e.preventDefault();
        sendForm($(this), "send-contact.php", afterSend);
        return false;
    });

    $(".nemovitost-form").on("submit", function (e) {
        e.preventDefault();
        sendForm($(this), "send-nemovitost.php", afterSend);
        return false;
    });
}

function afterSend(data) {
    // Callback function after successful form submission
    window.location.href = thankyoupage;
    console.log("Form submitted successfully:", data);
}

function sendForm($form, service, afterSendMethod) {
    let hasError = false;

    // Clear previous error states
    $form.find(".form-control").removeClass("hasErrorEmpty hasErrorFormat");
    $form.find(".form-error-message").removeClass("active");
    $form.find(".error-message").removeClass("active").find("p").text("");

    // Validate required fields
    $form.find("input[required], textarea[required]").each(function () {
        if (!$(this).val().trim()) {
            hasError = true;
            $(this).addClass("hasErrorEmpty");
            $(this).closest(".form-group").find(".form-error-message--empty").addClass("active");
        }
    });

    // Validate email format
    $form.find("input[data-format='email']").each(function () {
        const $input = $(this);
        const value = $input.val().trim();
        if ($input.prop("required") && !value) {
            hasError = true;
            $input.addClass("hasErrorEmpty");
            $input.closest(".form-group").find(".form-error-message--empty").addClass("active");
        } else if (value && !validateEmail(value)) {
            hasError = true;
            $input.addClass("hasErrorFormat");
            $input.closest(".form-group").find(".form-error-message--format").addClass("active");
        }
    });

    // Validate phone format
    $form.find("input[data-format='phone']").each(function () {
        const $input = $(this);
        const value = $input.val().trim();
        if ($input.prop("required") && !value) {
            hasError = true;
            $input.addClass("hasErrorEmpty");
            $input.closest(".form-group").find(".form-error-message--empty").addClass("active");
        } else if (value && !validatePhone(value)) {
            hasError = true;
            $input.addClass("hasErrorFormat");
            $input.closest(".form-group").find(".form-error-message--format").addClass("active");
        }
    });

    // Validate GDPR checkbox
    const $gdprCheckbox = $form.find("input[name='register-gdpr']");
    if (!$gdprCheckbox.is(":checked")) {
        hasError = true;
        $form.find(".gdpr-wrapper").addClass("hasError");
        $form.find(".error-message").addClass("active").find("p").text("Je vyžadován souhlas se zpracováním osobních údajů.");
    }

    // Show general error message if any validation failed
    if (hasError) {
        $form
            .find(".error-message")
            .addClass("active")
            .find("p")
            .text($form.find(".error-message p").text() || "Prosím, vyplňte všechny povinné údaje správně.");
        return false;
    }

    // Add spinner to button and disable it
    const $submitButton = $form.find("button.send");
    const originalButtonText = $submitButton.find(".btn__text").text();
    $submitButton.addClass("loading").prop("disabled", true).find(".btn__text").html('<span class="spinner"></span>');

    // Send form via AJAX
    $form.addClass("loading");
    $.ajax({
        url: formServicesDirectory + service,
        type: "POST",
        data: $form.serialize(),
        dataType: "json",
        success: function (data) {
            // Restore button text and enable button
            $submitButton.removeClass("loading").prop("disabled", false).find(".btn__text").text(originalButtonText);

            $form.find("input:not([type='hidden']), textarea").val("");
            $form.find("input[type='checkbox']").prop("checked", false);
            $form.removeClass("loading");
            $form.find(".form-row").addClass("hidden");
            $form.append('<div class="success-message">Formulář byl úspěšně odeslán.</div>');

            if (typeof afterSendMethod === "function") {
                afterSendMethod(data);
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            // Restore button text and enable button
            $submitButton.removeClass("loading").prop("disabled", false).find(".btn__text").text(originalButtonText);

            $form.removeClass("loading");
            $form.find(".error-message").addClass("active").find("p").text("Při odesílání formuláře došlo k chybě.");
            console.error("Form submission error:", textStatus, errorThrown);
        },
    });
}

function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email.toLowerCase());
}

function validatePhone(phone) {
    // More permissive phone number validation
    const re = /^\+?([0-9\s-]{9,})$/;
    return re.test(phone);
}

// Initialize forms on document ready
$(document).ready(function () {
    initForms();
});

jQuery(document).ready(function ($) {
    $(".load-more-button").on("click", function (e) {
        e.preventDefault();
        // Find hidden cards
        var $hiddenCards = $(".cards__card:hidden");
        // Show the next 3 hidden cards
        $hiddenCards.slice(0, 3).slideDown(600);
        // If no more hidden cards, hide the button
        if ($hiddenCards.length <= 3) {
            $(".load-more-button").hide();
        }
    });
});
